export interface ReservationCalendarSelectionState {
   mouseDown: boolean,
   rowId: string | undefined,
   startColIndex: number | undefined,
   endColIndex: number | undefined,
}

export const DefaultSelection: ReservationCalendarSelectionState = {
   mouseDown: false,
   rowId: undefined,
   startColIndex: undefined,
   endColIndex: undefined,
}